// Ruta base de la app (sin dependencias, para que las secciones naveguen sin
// importar config.tsx, que a su vez importa las secciones).
export const MANTENIMIENTO_BASE = "/mantenimiento";
